// extracted by mini-css-extract-plugin
export default {"nav_nolink":"nav_nolink__y+6kl","nm":"nm__aPVRB","adjtab3":"adjtab3__ORjps","adjtab4":"adjtab4__kfZ17","limain":"limain__lRWKz","active":"active__-K2pg"};